// extracted by mini-css-extract-plugin
export default {"icon":"ErrorBoundary_icon__Za0pu"};